export default [{
	titulo: 'Banners',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/banners',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]